import type { AsyncItemStatus, AsyncTaskState } from 'owa-copilot-async-chat-types';

/**
 * Collapses a raw async status into one of the four task states, or `undefined` when the item
 * should not be surfaced at all (`None` has no turn yet, `Canceled` is dismissed).
 */
export function getAsyncTaskState(status: AsyncItemStatus): AsyncTaskState | undefined {
    switch (status) {
        case 'Completed':
            return 'completed';
        case 'InputRequired':
        case 'Paused':
            return 'needsAttention';
        case 'Failed':
            return 'failed';
        case 'Working':
            return 'inProgress';
        case 'None':
        case 'Canceled':
        default:
            return undefined;
    }
}
